import { Input } from "@repo/ui/Inputs/input";
import { Textarea } from "@repo/ui/Inputs/textarea";
import type { FC } from "react";

interface SharedToolFormFieldsProps {
  name: string;
  description: string;
  onNameChange: (name: string) => void;
  onDescriptionChange: (description: string) => void;
  namePlaceholder: string;
  descriptionPlaceholder: string;
}

export const SharedToolFormFields: FC<SharedToolFormFieldsProps> = ({
  name,
  description,
  onNameChange,
  onDescriptionChange,
  namePlaceholder,
  descriptionPlaceholder,
}) => {
  return (
    <>
      <Input
        id="name"
        label="Name"
        value={name}
        onChange={(e) => onNameChange(e.target.value)}
        placeholder={namePlaceholder}
        maxLength={100}
      />

      <div className="col-span-full">
        <Textarea
          id="description"
          label="Description"
          value={description}
          onChange={onDescriptionChange}
          description="Clearly describe what this tool does and how it should be used by the voice agent."
          placeholder={descriptionPlaceholder}
        />
      </div>
    </>
  );
};
